import $ from 'jquery';

/** Internal Dependencies */
import { NCST } from '../';
import { ControllerComponent } from './ControllerComponent';

export default class CampaignSticker extends ControllerComponent {
	constructor() {
		super();

		this.elements = {
			nav: $( '#website-nav' ),
			navContainer: $( '.website-nav__container > .menu' ),
			sticker: $( '#website-nav .campaign-sticker' ),
		};

		this.state = {
			isFloated: false,
		};
	}

	init() {
		if ( this.elements.sticker && ! this.elements.sticker.length ) {
			return;
		}

		// Setup state and resize listener
		this.setStickerState();
		NCST.elements.$win.on(
			'ncst_resized',
			this.setStickerState.bind( this )
		);
	}

	setStickerState() {
		const stickerWidth = this.elements.sticker.outerWidth();

		this.elements.sticker.hide();

		let availableSpace = parseInt(
			this.elements.navContainer.css( 'margin-right' )
		);
		const isFloated = availableSpace >= stickerWidth;

		this.elements.sticker.show();

		this.setState( {
			isFloated: isFloated,
		} );
	}

	render() {
		this.elements.nav.toggleClass(
			'campaign-sticker-floated',
			this.state.isFloated
		);
		NCST.controllers.navigation.setNavState(); // Sticker position affects nav state
	}
}
